/**
 * Created by marc on 14.05.17.
 */

export * from './dist';



// WEBPACK FOOTER //
// ./~/ng2-archwizard/index.ts